const preBuyUtils = new window.PreBuyUtils()
class ProductVariantAtc {
  constructor () {
    this.setupListeners()

    this.connectedCallback()
  }

  async connectedCallback () {
    this.checkPreBuy()
  }

  setupListeners () {
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  }

  checkPreBuy () {
    const addToCartButtons = document.querySelectorAll(
      `[data-product-variant-atc-el="button"]`,
    )
    addToCartButtons.forEach(async el => {
      if (el.dataset.checkPreBuy === undefined) return
      const productId = el.dataset.productId
      const variantId = el.dataset.variantId

      if (!productId || !variantId) return

      const preBuyData = await preBuyUtils.getPreBuyData(productId, variantId)

      if (preBuyData.quantityAvailable > 0 && !preBuyData.inventoryAvailable) {
        return
      }

      if (preBuyData?.enabled && !preBuyData?.variantPool) {
        el.disabled = true
        el.classList.add('prd-Card_Link-soldOut')
      }
    })
  }

  async handleDocumentClick (e) {
    const button = e.target?.closest('[data-product-variant-atc-el="button"]')
    if (!button) return

    const variantId = button.getAttribute('data-variant-id')
    if (variantId) {
      await this.addVariantToCart(variantId)
    }
  }

  async addVariantToCart (variantId) {
    try {
      const button = document.querySelector(
        `[data-product-variant-atc-el="button"][data-variant-id="${variantId}"]`,
      )

      const properties = {}

      const preOrderDate = button?.getAttribute('data-variant-pre-order')
      const startDate = button?.getAttribute('data-variant-start-date')

      const preBuyData = await preBuyUtils.getPreBuyData(
        button.getAttribute('data-product-id'),
        variantId,
      )
      let sellingPlanId = ''
      if (preBuyData?.enabled && preBuyData?.variantPool) {
        sellingPlanId =
          preBuyData?.variantPool?.sellingPlanId?.replace(
            'gid://shopify/SellingPlan/',
            '',
          ) || ''
        properties._preorder = 'true'
        properties[window.theme?.strings?.estimated_dispatch || 'Pre-order'] =
          preBuyData?.variantPool?.estDispatchDateFormatted
        properties._pool_location = preBuyData?.variantPool?.location
        properties._dispatch_date = preBuyData.variantPool?.estDispatchDate
        const date = new Date(preBuyData?.variantPool?.estDispatchDate)
        const month = date.getMonth() + 1
        properties._start_date = `${String(month).padStart(2, '0')}/${String(
          date.getDate(),
        ).padStart(2, '0')}/${date.getFullYear()}`
      } else {
        if (preOrderDate) {
          properties._preorder = 'true'
          properties[
            window.theme?.strings?.estimated_dispatch || 'Pre-order'
          ] = preOrderDate
        }
      }

      if (startDate) {
        properties._start_date = startDate
      }

      window.BAO.Cart.addItem({
        id: parseInt(variantId),
        quantity: 1,
        selling_plan: sellingPlanId ? parseInt(sellingPlanId, 10) : null,
        ...(Object.keys(properties).length ? { properties } : {}),
      })
    } catch (error) {
      console.error('Error adding variant:', error)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.productVariantAtc = new ProductVariantAtc()
})
